import React from "react"

function HeaderC() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path stroke="var(--base-300)" d="M266 38.5H0" />
      <rect
        x={217}
        y={14}
        width={29}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <circle cx={133} cy={19} r={9} fill="var(--main-500)" />
      <rect
        x={62.264}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={41.132}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={83.396}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={17}
        width={16.604}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default HeaderC;
